import React, { useEffect } from 'react';
import './Modal.css';

const Modal = ({ message, type, isVisible, onClose }) => {
    useEffect(() => {
        if (isVisible) {
            const timer = setTimeout(onClose, 3000);
            localStorage.setItem('show_modal', 'false');
            return () => clearTimeout(timer);
        }
    }, [isVisible, onClose]);

    if (!isVisible) return null;

    return (
        <div className="modal-overlay">
            <div className={`modal-box ${type}`}>
                <p>{message}</p>
            </div>
        </div>
    );
};

export default Modal;
